// Normalizes any error (axios/FastAPI/network) into a plain display string.
//
// Why this exists: FastAPI's HTTPException can return `detail` as a string, as a
// structured object ({ error, message, ... } — used by our credit endpoints), or as a
// validation array ([{ loc, msg, type }, ...]). Passing a non-string straight into JSX
// (e.g. a toast message) throws React error #31 ("Objects are not valid as a React
// child"), which — with no error boundary — unmounts the whole tree and blanks the page.
// Always route error text through this helper before rendering it.
export function getErrorMessage(error, fallback = "Something went wrong. Please try again.") {
  const detail = error?.response?.data?.detail;

  // Structured object detail: { error, message, ... }
  if (detail && typeof detail === "object" && !Array.isArray(detail)) {
    if (typeof detail.message === "string" && detail.message) return detail.message;
    if (typeof detail.error === "string" && detail.error) return detail.error;
  }

  // FastAPI validation errors: [{ loc, msg, type }, ...]
  if (Array.isArray(detail)) {
    const withMsg = detail.find((d) => d && typeof d.msg === "string" && d.msg);
    if (withMsg) return withMsg.msg;
  }

  // Plain string detail
  if (typeof detail === "string" && detail) return detail;

  // Some endpoints put the message at the top level of the body
  const topMessage = error?.response?.data?.message;
  if (typeof topMessage === "string" && topMessage) return topMessage;

  // Axios / network error message
  if (typeof error?.message === "string" && error.message) return error.message;

  return fallback;
}

export default getErrorMessage;
